import type { FunctionComponent } from 'react';
import * as s from './ConsultantListing.css';
import type * as T from './ConsultantListing.types';
import classNames from 'classnames';
import ConsultantItem from '../ConsultantItem';
const ConsultantListing: FunctionComponent<T.IConsultantListingProps> = (props) => {
    const { className, consultants, view = 'row', isBorderedImage, clickCounterName, avatarType, } = props;
    return (<ul className={classNames(s.root, className)}>
      {consultants.map((consultant) => (<li className={s.item} key={consultant.id}>
          <ConsultantItem consultant={consultant} view={view} avatarType={avatarType} isBorderedImage={isBorderedImage} clickCounterName={clickCounterName}/>
        </li>))}
    </ul>);
};
export default ConsultantListing;
